// WDCE-199 step 9g-4a (D56): whether the rest of the POS checkout is locked while the EFTPOS panel is active, the line
// saying why, and which payment types the radios offer. No React, fetch or DOM here, so it can be tested with
// bin/js-test; FoodTableOrder (9g-4b) passes the results on. The server refuses the changes anyway (4a, 9b, 9g-2):
// this only keeps the screen from offering them.
//
// - checkoutLock: lockable while the panel is on (FoodTableOrder then always renders the lockable form, so locking
//   never remounts its fields). Locked while the panel is active (panelView's view.active: a payment starting, in
//   flight, unknown, being checked or approved, or the order part paid) and while the checkout PATCH is out. The line:
//   a payment in flight first, as the server refuses a change as payment_in_progress before it looks for an approval;
//   then an approved payment on an order still open; then the server's part-paid lock message. None while saving: the
//   panel says "Saving the order...".
// - offeredPaymentTypes: once part is paid, only EFTPOS (the server refuses cash and card then, 9b). With the panel
//   off, no EFTPOS: nothing would take it (a guard: since 9h-3 the server lists it only when it's offered). Otherwise
//   the same object.

export const PAYMENT_IN_PROGRESS = 'A payment is in progress on this order.'
export const PARTLY_PAID_LOCKED =
  "Part of this order has been paid by EFTPOS. It can't be changed until the rest is paid."
export const APPROVED_LOCKED = "An EFTPOS payment on this order has been approved, so it can't be changed."

const IN_FLIGHT_PHASES = ['starting', 'waiting', 'inProgress', 'unknown', 'checking']
const IN_FLIGHT_STATUSES = ['pending', 'in_progress', 'unknown']

const isObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value)

function lockMessage(state) {
  const payment = state.payment
  if (IN_FLIGHT_PHASES.includes(state.phase) || (payment && IN_FLIGHT_STATUSES.includes(payment.status))) {
    return PAYMENT_IN_PROGRESS
  }
  if (state.phase === 'approved') return APPROVED_LOCKED
  if (state.eftposApproved) return PARTLY_PAID_LOCKED

  return null
}

export function checkoutLock({ enabled, state, view, checkingOut }) {
  if (enabled !== true || !isObject(state)) return { lockable: false, locked: false, message: null }

  const active = Boolean(view && view.active)
  return {
    lockable: true,
    locked: active || checkingOut === true,
    message: active ? lockMessage(state) : null
  }
}

export function offeredPaymentTypes(paymentTypes, { enabled, eftposApproved }) {
  if (!isObject(paymentTypes) || !Object.prototype.hasOwnProperty.call(paymentTypes, 'eftpos')) return paymentTypes

  if (enabled !== true) {
    return Object.keys(paymentTypes).filter((key) => key !== 'eftpos')
      .reduce((offered, key) => ({ ...offered, [key]: paymentTypes[key] }), {})
  }
  return eftposApproved === true ? { eftpos: paymentTypes.eftpos } : paymentTypes
}
